export default {
  zh: {
    custom_shot: '多分镜',
    shot: '镜头',
    shot_index: '镜头{index}',
    image_label: '图片{index}',
    reference_images: '图片参考',
    image_reference_missing: '图片{index} 已失效',
    click_to_reselect_image: '点击重新选择图片',
    add_shot: '镜头',
    add_shot_btn: '分镜',
    total_duration: '总时长',
    at_least_one_shot: '请至少填写一个分镜描述',
    all_shots_required: '请填写所有分镜内容',
    at_least_one_intelligent_prompt: '请至少填写一个智能提示词描述',
    adjust_duration_before_add: '已达到当前总时长上限，请先调整时长',
    describe_shot: '请描述镜头信息',
    describe_shot_with_at: '输入 @ 选择图片元素，再描述镜头内容',
    input_at_to_insert_image: '输入 @ 可插入图片元素，并继续补充动作描述',
    normal: '正常模式',
    auto: '智能分镜',
    custom: '自定义分镜',
  },
  en: {
    custom_shot: 'Multi-shot',
    shot: 'Shot',
    shot_index: 'Shot {index}',
    image_label: 'Image {index}',
    reference_images: 'Reference Images',
    image_reference_missing: 'Image {index} missing',
    click_to_reselect_image: 'Click to reselect image',
    add_shot: 'Add Shot',
    add_shot_btn: 'Storyboard',
    total_duration: 'Total Duration',
    at_least_one_shot: 'Please fill in at least one shot prompt',
    all_shots_required: 'Please fill in all shot prompts',
    at_least_one_intelligent_prompt: 'Please fill in at least one intelligent prompt',
    adjust_duration_before_add: 'The current total duration has reached the limit, please adjust the duration first',
    describe_shot: 'Please describe the shot information',
    describe_shot_with_at: 'Type @ to insert an image element, then continue describing the shot',
    input_at_to_insert_image: 'Type @ to insert an image element and continue the action description',
    normal: 'Normal',
    auto: 'Auto Storyboard',
    custom: 'Custom Storyboard',
  },
  ja: {
    custom_shot: '多分鏡',
    shot: 'ショット',
    shot_index: 'ショット{index}',
    image_label: '画像{index}',
    reference_images: '画像リファレンス',
    image_reference_missing: '画像{index} は無効です',
    click_to_reselect_image: 'クリックして画像を再選択',
    add_shot: 'ショットを追加',
    add_shot_btn: '絵コンテ',
    total_duration: '合計時間',
    at_least_one_shot: '少なくとも1つのショット説明を入力してください',
    all_shots_required: 'すべてのショット内容を入力してください',
    adjust_duration_before_add: '現在の合計時間が上限に達しました。時間を調整してください。',
    describe_shot: 'ショット情報を説明してください',
    normal: '通常モード',
    auto: 'スマート絵コンテ',
    custom: 'カスタム絵コンテ',
  },
  ko: {
    custom_shot: '다중 샷',
    shot: '샷',
    shot_index: '샷 {index}',
    image_label: '이미지 {index}',
    reference_images: '이미지 참조',
    image_reference_missing: '이미지 {index} 참조가 만료됨',
    click_to_reselect_image: '클릭하여 이미지를 다시 선택',
    add_shot: '샷 추가',
    add_shot_btn: '스토리보드',
    total_duration: '총 길이',
    at_least_one_shot: '최소 한 개의 샷 설명을 입력해 주세요',
    all_shots_required: '모든 샷 내용을 입력해 주세요',
    adjust_duration_before_add: '현재 총 시간이 제한에 도달했습니다. 시간을 조정해 주세요.',
    describe_shot: '샷 정보를 설명해 주세요',
    normal: '일반 모드',
    auto: '스마트 스토리보드',
    custom: '커스텀 스토리보드',
  },
  tw: {
    custom_shot: '多分鏡',
    shot: '鏡頭',
    shot_index: '鏡頭{index}',
    image_label: '圖片{index}',
    reference_images: '圖片參考',
    image_reference_missing: '圖片{index} 已失效',
    click_to_reselect_image: '點擊重新選擇圖片',
    add_shot: '新增鏡頭',
    add_shot_btn: '分鏡',
    total_duration: '總時長',
    at_least_one_shot: '請至少填寫一個分鏡描述',
    all_shots_required: '請填寫所有分鏡內容',
    at_least_one_intelligent_prompt: '請至少填寫一個智能提示詞描述',
    adjust_duration_before_add: '目前總時間已達上限，請先調整時間',
    describe_shot: '請描述鏡頭信息',
    describe_shot_with_at: '輸入 @ 選擇圖片元素，再描述鏡頭內容',
    input_at_to_insert_image: '輸入 @ 可插入圖片元素，並繼續補充動作描述',
    normal: '正常模式',
    auto: '智能分鏡',
    custom: '自定義分鏡',
  },
  pl: {
    custom_shot: 'Wiele ujęć',
    shot: 'Ujęcie',
    shot_index: 'Ujęcie {index}',
    image_label: 'Image {index}',
    reference_images: 'Odniesienie obrazu',
    image_reference_missing: 'Image {index} missing',
    click_to_reselect_image: 'Click to reselect image',
    add_shot: 'Dodaj ujęcie',
    add_shot_btn: 'Storyboard',
    total_duration: 'Czas całkowity',
    at_least_one_shot: 'Wpisz co najmniej jeden opis ujęcia',
    all_shots_required: 'Please fill in all shot prompts',
    adjust_duration_before_add: 'Czas całkowity osiągnął limit. Proszę przeprowadzić korektę czasu.',
    describe_shot: 'Opisz informacje o ujęciu',
    normal: 'Normalny',
    auto: 'Smart storyboard',
    custom: 'Własny storyboard',
  },
  es: {
    custom_shot: 'Múltiples tomas',
    shot: 'Toma',
    shot_index: 'Toma {index}',
    image_label: 'Imagen {index}',
    reference_images: 'Referencia de imagen',
    image_reference_missing: 'Image {index} missing',
    click_to_reselect_image: 'Click to reselect image',
    add_shot: 'Agregar toma',
    add_shot_btn: 'Storyboard',
    total_duration: 'Duracion total',
    at_least_one_shot: 'Completa al menos una descripcion de toma',
    all_shots_required: 'Please fill in all shot prompts',
    adjust_duration_before_add: 'La duración total ha alcanzado el límite. Por favor, ajuste la duración.',
    describe_shot: 'Describe la información de la toma',
    normal: 'Normal',
    auto: 'Storyboard inteligente',
    custom: 'Storyboard personalizado',
  },
  fr: {
    custom_shot: 'Multi-plans',
    shot: 'Plan',
    shot_index: 'Plan {index}',
    image_label: 'Image {index}',
    reference_images: 'Reference d’image',
    image_reference_missing: 'Image {index} missing',
    click_to_reselect_image: 'Click to reselect image',
    add_shot: 'Ajouter un plan',
    add_shot_btn: 'Storyboard',
    total_duration: 'Duree totale',
    at_least_one_shot: 'Veuillez renseigner au moins une description de plan',
    all_shots_required: 'Please fill in all shot prompts',
    adjust_duration_before_add: 'La durée totale a atteint la limite. Veuillez ajuster la durée.',
    describe_shot: 'Décrivez les informations de la prise',
    normal: 'Normal',
    auto: 'Storyboard auto',
    custom: 'Storyboard personnalisé',
  },
  de: {
    custom_shot: 'Mehrere Aufnahmen',
    shot: 'Aufnahme',
    shot_index: 'Aufnahme {index}',
    image_label: 'Bild {index}',
    reference_images: 'Bildreferenz',
    image_reference_missing: 'Image {index} missing',
    click_to_reselect_image: 'Click to reselect image',
    add_shot: 'Aufnahme hinzufugen',
    add_shot_btn: 'Storyboard',
    total_duration: 'Gesamtdauer',
    at_least_one_shot: 'Bitte mindestens eine Aufnahmebeschreibung eingeben',
    all_shots_required: 'Please fill in all shot prompts',
    adjust_duration_before_add: 'Die Gesamtdauer hat das Limit erreicht. Bitte passen Sie die Dauer an.',
    describe_shot: 'Beschreibe die Aufnahmeinformationen',
    normal: 'Normal',
    auto: 'Smart-Storyboard',
    custom: 'Benutzerdefiniertes Storyboard',
  },
  ru: {
    custom_shot: 'Много кадров',
    shot: 'Кадр',
    shot_index: 'Кадр {index}',
    image_label: 'Изображение {index}',
    reference_images: 'Референс изображения',
    image_reference_missing: 'Image {index} missing',
    click_to_reselect_image: 'Click to reselect image',
    add_shot: 'Добавить кадр',
    add_shot_btn: 'Раскадровка',
    total_duration: 'Общая длительность',
    at_least_one_shot: 'Пожалуйста, заполните хотя бы одно описание кадра',
    all_shots_required: 'Please fill in all shot prompts',
    adjust_duration_before_add: 'Общая длительность достигла предела. Пожалуйста, отрегулируйте длительность.',
    describe_shot: 'Опишите информацию о кадре',
    normal: 'Обычный',
    auto: 'Умная раскадровка',
    custom: 'Пользовательская раскадровка',
  },
  pt: {
    custom_shot: 'Múltiplas tomas',
    shot: 'Tomada',
    shot_index: 'Tomada {index}',
    image_label: 'Imagem {index}',
    reference_images: 'Referencia de imagem',
    image_reference_missing: 'Image {index} missing',
    click_to_reselect_image: 'Click to reselect image',
    add_shot: 'Adicionar tomada',
    add_shot_btn: 'Storyboard',
    total_duration: 'Duracao total',
    at_least_one_shot: 'Preencha pelo menos uma descricao de tomada',
    all_shots_required: 'Please fill in all shot prompts',
    adjust_duration_before_add: 'A duração total atingiu o limite. Por favor, ajuste a duração.',
    describe_shot: 'Descreva as informações da tomada',
    normal: 'Normal',
    auto: 'Storyboard automático',
    custom: 'Storyboard personalizado',
  },
  it: {
    custom_shot: 'Múltiple inquadrature',
    shot: 'Inquadratura',
    shot_index: 'Inquadratura {index}',
    image_label: 'Immagine {index}',
    reference_images: 'Riferimento immagine',
    image_reference_missing: 'Image {index} missing',
    click_to_reselect_image: 'Click to reselect image',
    add_shot: 'Aggiungi inquadratura',
    add_shot_btn: 'Storyboard',
    total_duration: 'Durata totale',
    at_least_one_shot: 'Inserisci almeno una descrizione inquadratura',
    all_shots_required: 'Please fill in all shot prompts',
    adjust_duration_before_add: 'La durata totale ha raggiunto il limite. Per favore, regola la durata.',
    describe_shot: 'Descrivi le informazioni del frame',
    normal: 'Normale',
    auto: 'Storyboard automatico',
    custom: 'Storyboard personalizzato',
  },
  ar: {
    custom_shot: 'لقطات متعددة',
    shot: 'لقطة',
    shot_index: 'لقطة {index}',
    image_label: 'صورة {index}',
    reference_images: 'مرجع الصورة',
    image_reference_missing: 'Image {index} missing',
    click_to_reselect_image: 'Click to reselect image',
    add_shot: 'إضافة لقطة',
    add_shot_btn: 'قصة مصورة',
    total_duration: 'المدة الإجمالية',
    at_least_one_shot: 'يرجى إدخال وصف لقطة واحد على الأقل',
    all_shots_required: 'Please fill in all shot prompts',
    adjust_duration_before_add: 'المدة الإجمالية وصلت إلى الحد الأقصى. يرجى ضبط المدة.',
    describe_shot: 'وصف المعلومات المرتبطة باللقطة',
    normal: 'عادي',
    auto: 'قصة مصورة ذكية',
    custom: 'قصة مصورة مخصصة',
  },
  th: {
    custom_shot: 'ช็อตหลายตำแหน่ง',
    shot: 'ช็อต',
    shot_index: 'ช็อต {index}',
    image_label: 'รูปภาพ {index}',
    reference_images: 'รูปภาพอ้างอิง',
    image_reference_missing: 'Image {index} missing',
    click_to_reselect_image: 'Click to reselect image',
    add_shot: 'เพิ่มช็อต',
    add_shot_btn: 'สตอรี่บอร์ด',
    total_duration: 'ระยะเวลารวม',
    at_least_one_shot: 'กรุณากรอกคำอธิบายช็อตอย่างน้อยหนึ่งรายการ',
    all_shots_required: 'Please fill in all shot prompts',
    adjust_duration_before_add: 'ระยะเวลารวมได้ถึงขีดจำกัด โปรดปรับระยะเวลา',
    describe_shot: 'อธิบายข้อมูลของช็อต',
    normal: 'ปกติ',
    auto: 'สตอรี่บอร์ดอัตโนมัติ',
    custom: 'สตอรี่บอร์ดกำหนดเอง',
  },
  da: {
    custom_shot: 'Flere optagelser',
    shot: 'Optagelse',
    shot_index: 'Optagelse {index}',
    image_label: 'Billede {index}',
    reference_images: 'Billedreference',
    image_reference_missing: 'Image {index} missing',
    click_to_reselect_image: 'Click to reselect image',
    add_shot: 'Tilfoj optagelse',
    add_shot_btn: 'Storyboard',
    total_duration: 'Samlet varighed',
    at_least_one_shot: 'Udfyld mindst en optagelsesbeskrivelse',
    all_shots_required: 'Please fill in all shot prompts',
    adjust_duration_before_add: 'Samlet varighed har nået grænsen. Venligst juster varigheden.',
    describe_shot: 'Beskriv optagelsesinformationerne',
    normal: 'Normal',
    auto: 'Smart storyboard',
    custom: 'Brugerdefineret storyboard',
  },
  no: {
    custom_shot: 'Flere opptak',
    shot: 'Opptak',
    shot_index: 'Opptak {index}',
    image_label: 'Bilde {index}',
    reference_images: 'Bildereferanse',
    image_reference_missing: 'Image {index} missing',
    click_to_reselect_image: 'Click to reselect image',
    add_shot: 'Legg til opptak',
    add_shot_btn: 'Storyboard',
    total_duration: 'Total varighet',
    at_least_one_shot: 'Fyll inn minst en opptaksbeskrivelse',
    all_shots_required: 'Please fill in all shot prompts',
    adjust_duration_before_add: 'Total varighet har nådd grensen. Venligst juster varigheten.',
    describe_shot: 'Beskriv opptaksinformasjonen',
    normal: 'Normal',
    auto: 'Smart storyboard',
    custom: 'Egendefinert storyboard',
  },
  nl: {
    custom_shot: 'Meerdere shots',
    shot: 'Shot',
    shot_index: 'Shot {index}',
    image_label: 'Afbeelding {index}',
    reference_images: 'Afbeeldingsreferentie',
    image_reference_missing: 'Image {index} missing',
    click_to_reselect_image: 'Click to reselect image',
    add_shot: 'Shot toevoegen',
    add_shot_btn: 'Storyboard',
    total_duration: 'Totale duur',
    at_least_one_shot: 'Vul minimaal een shotbeschrijving in',
    all_shots_required: 'Please fill in all shot prompts',
    adjust_duration_before_add: 'De totale duur heeft het limiet bereikt. Pas de duur aan.',
    describe_shot: 'Beschrijf de opnameinformatie',
    normal: 'Normaal',
    auto: 'Smart storyboard',
    custom: 'Aangepast storyboard',
  },
  id: {
    custom_shot: 'Bidikan lebih banyak',
    shot: 'Bidikan',
    shot_index: 'Bidikan {index}',
    image_label: 'Gambar {index}',
    reference_images: 'Referensi gambar',
    image_reference_missing: 'Image {index} missing',
    click_to_reselect_image: 'Click to reselect image',
    add_shot: 'Tambah bidikan',
    add_shot_btn: 'Storyboard',
    total_duration: 'Total durasi',
    at_least_one_shot: 'Harap isi setidaknya satu deskripsi bidikan',
    all_shots_required: 'Please fill in all shot prompts',
    adjust_duration_before_add: 'Total durasi telah mencapai batas. Silakan atur durasi.',
    describe_shot: 'Deskripsikan informasi bidikan',
    normal: 'Normal',
    auto: 'Storyboard otomatis',
    custom: 'Storyboard kustom',
  },
  tr: {
    custom_shot: 'Çoklu kamera',
    shot: 'Cekim',
    shot_index: 'Cekim {index}',
    image_label: 'Gorsel {index}',
    reference_images: 'Gorsel referansi',
    image_reference_missing: 'Image {index} missing',
    click_to_reselect_image: 'Click to reselect image',
    add_shot: 'Cekim ekle',
    add_shot_btn: 'Storyboard',
    total_duration: 'Toplam sure',
    at_least_one_shot: 'Lutfen en az bir cekim aciklamasi girin',
    all_shots_required: 'Please fill in all shot prompts',
    adjust_duration_before_add: 'Toplam süre limitine ulaştı. Lütfen süreyi ayarlayın.',
    describe_shot: 'Cekim bilgilerini açıklayın',
    normal: 'Normal',
    auto: 'Akıllı storyboard',
    custom: 'Özel storyboard',
  },
}
